import './style.css';
import { Engine } from './core/Engine';

window.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('gameCanvas') as HTMLCanvasElement;
  const menuContainer = document.getElementById('ui-layer') as HTMLElement;
  const hudContainer = document.getElementById('hud-layer') as HTMLElement;

  if (!canvas || !menuContainer || !hudContainer) {
    throw new Error('Required DOM elements not found in document');
  }

  // Initialize PolyPong Engine
  new Engine(canvas, menuContainer, hudContainer);
});
